/*
 * Provide some specific functionality for the Agency Search popup window
 *   to supplement the generic SearchResultPicker logic.
 */

// Setup the namespace for this logic
var agencySearchPicker = agencySearchPicker || {};


agencySearchPicker.initialize = function() {

	ap.consoleInfo("agencySearchPicker initialize!");

	var agencySearchResultPickerObj = searchResultPicker.getSearchResultPicker("AgencySearchPicker");

	if (agencySearchResultPickerObj) {
		/*
		 * Establish some data entry limits/formats for the popup window.  This logic
		 *   is intended to be applied just after the Overlib library displays the page.
		 */
		agencySearchResultPickerObj.customSearchResultPickerPostDisplay = function(picker) {
			ap.consoleInfo("agencySearchPicker.customSearchResultPickerPostDisplay called!");
	
			// Establish some data entry limits on name, city, and zipcode fields
			document.getElementById("AgencySearchPicker-SearchName").maxLength = 75;
			document.getElementById("AgencySearchPicker-SearchCity").maxLength = 20;
			document.getElementById("AgencySearchPicker-SearchZip").maxLength = 5;		
			document.getElementById("AgencySearchPicker-SearchPhone").maxLength = 10;	
			
			// Need to reset the State select list to not have a value.
			// Make sure the ApplicantAddressState being reset is specifically the field in the AgencySearchPicker.
			var pickerState = $('#'+picker.pickerId+' #ApplicantAddressState')[0];
			pickerState.options[0].selected = 'selected';
	
			// Apply (or safely re-apply) a format mask to phone number field
			var element = document.getElementById("AgencySearchPicker-SearchPhone");
			if (element && !picker.phoneFieldMask) {
				picker.phoneFieldMask = new ap.FieldMask({element:element.id, supportsMask:true, mask:"(###) ###-####", settings:{} });
			}
	
		};
	
		
		agencySearchResultPickerObj.customSearchResultPickerSearchSubmit = function(picker) {
			ap.consoleInfo("agencySearchPicker.customSearchResultPickerPostDisplay called!");
			var searchForm = document.forms["searchForm"];
			var zip = searchForm["AgencySearchPicker-SearchName"].value;
			var phone = searchForm["AgencySearchPicker-SearchPhone"].value;
			
			if(zip.length == 0  && phone.length == 0){
				alert("Either Name or Phone must be provided for search");
				return false;		
			}
			
			return true;
			
		};
	}
};



